export const getScrollBarWidth = () => {
  return window.innerWidth - document.body.clientWidth;
};
